export default __webpack_public_path__ + "static/media/dacminott.83f22052.png";